import { Panel } from "primereact/panel";
import { Tag } from "primereact/tag";
import type { ChangeEvent } from "react";
import { useRef } from "react";
import { formatDateTime } from "@/lib/utils";
import { parseDateTimeOrNull } from "@/lib/date-utils";
import type { AdminEvent } from "../types";

export function EventSidebar(props: {
  event: AdminEvent;
  onUploadFile: (file: File) => void;
}) {
  const { event } = props;
  const fileInputRef = useRef<HTMLInputElement>(null);
  const updatedAtMs = parseDateTimeOrNull(event.updatedAt)?.getTime();
  const imageUrl =
    event.imageUrl && updatedAtMs
      ? `${event.imageUrl}${event.imageUrl.includes("?") ? "&" : "?"}t=${updatedAtMs}`
      : event.imageUrl;

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    props.onUploadFile(file);

    // Allow selecting the same file again.
    e.target.value = "";
  };

  return (
    <div className="flex flex-column gap-4 event-detail-right-col" style={{ minWidth: 0, width: "100%" }}>
      {event.isBookable && (
        <Panel header="Image">
          {event.imageUrl ? (
            <div className="relative mb-3" style={{ position: "relative" }}>
              <img
                src={imageUrl ?? undefined}
                alt={event.title}
                className="w-full border-round"
              />
              <div
                className="absolute inset-0 flex align-items-center justify-content-center cursor-pointer border-round"
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.4)";
                }}
                onClick={() => fileInputRef.current?.click()}
              >
                <span className="text-white font-semibold">CLICK TO UPLOAD/REPLACE</span>
              </div>
            </div>
          ) : (
            <div
              className="w-full border-round mb-3 flex align-items-center justify-content-center cursor-pointer"
              style={{
                backgroundColor: "#e9ecef",
                minHeight: "200px",
                border: "2px dashed #dee2e6",
              }}
              onClick={() => fileInputRef.current?.click()}
            >
              <span className="text-gray-600 font-semibold">CLICK TO UPLOAD/REPLACE</span>
            </div>
          )}
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </Panel>
      )}

      <div>
        <h3 className="font-bold mb-2">Tags</h3>
        <div className="flex flex-wrap gap-2">
          {event.tags.map((tag) => (
            <Tag key={tag.tag.id} value={tag.tag.name} />
          ))}
          {event.tags.length === 0 && <span className="text-gray-500">No tags</span>}
        </div>
      </div>

      <div className="flex flex-column gap-2">
        <div>
          <span className="font-semibold">Created: </span>
          {event.createdAt ? formatDateTime(event.createdAt, event.timezone) : "-"}
        </div>
        <div>
          <span className="font-semibold">Updated: </span>
          {event.updatedAt ? formatDateTime(event.updatedAt, event.timezone) : "-"}
        </div>
      </div>
    </div>
  );
}


